import { FC } from 'react'
import { PetType } from '@fitpet/utils/pet-types'
import { GetStaticProps } from 'next'
import styled from 'styled-components'
import HomeBestCategorySelectTab from '@/components/domains/home/HomeBestCategorySelectTab'
import { LayoutHeader } from '@/components/domains/layouts'
import SeoHeader from '@/components/domains/layouts/header/SeoHeader'
import ListProducts from '@/components/domains/list/ListProducts'
import {
  BestSellerCategoryTypeEnum,
  BestSellerCategoryTypeKoreanText,
  bestTabNameToLegacySlug,
} from '@/constants/best-seller-category-type.enum'
import ROUTES from '@/constants/legacy/constRoutes'
import { useBestEventTracker } from '@/containers/event-tracker/best-event-tracker'
import { usePetType } from '@/containers/hooks'
import useBestSellerProductsListV3 from '@/containers/hooks/bestSeller/bestSellerProductsListV3.container.hook'
import useCustomRouter from '@/containers/hooks/useCustomRouter'
import { AdPetType } from '@/graphql/generated/schemas'
import { getPetTypeRootCategoryKoreanText } from '@/utils/utilCategory'

type PageHomeBestSellerCategoryProps = {
  isHome?: boolean
}

const PageHomeBestSellerCategory: FC<PageHomeBestSellerCategoryProps> = ({ isHome = true }) => {
  const { query } = useCustomRouter()
  const { petType } = query as { petType: PetType }
  const { getPetType } = usePetType()

  const router = useCustomRouter()
  const { categoryName } = router.query as { categoryName: string }
  const _petType = petType || getPetType()

  const { categoryTabs, selectedId, changeTab } = useBestSellerProductsListV3()

  const { trackClickBestSellerTabEvent } = useBestEventTracker()

  const goToAnotherCategory = (id: number, name?: string) => {
    const pathname = isHome ? ROUTES.HOME.BEST_SELLER : ROUTES.BEST_SELLER

    const getLegacySlug = bestTabNameToLegacySlug(name)
    trackClickBestSellerTabEvent(name)
    router.replace(
      {
        pathname,
        query: {
          categoryName: getLegacySlug || BestSellerCategoryTypeEnum.All,
        },
      },
      undefined,
      { shallow: true }
    )
    changeTab(id)
  }

  return (
    <>
      <SeoHeader
        title={`베스트 ${BestSellerCategoryTypeKoreanText[categoryName as BestSellerCategoryTypeEnum]} - 핏펫몰`}
        metaDescription={`핏펫이 자신있게 추천하는 ${getPetTypeRootCategoryKoreanText(_petType as AdPetType)} 베스트 ${
          BestSellerCategoryTypeKoreanText[categoryName as BestSellerCategoryTypeEnum]
        }입니다.`}
        pathname={ROUTES.HOME.BEST_SELLER.replace('[categoryName]', categoryName)}
      />
      <LayoutHeader />
      <>
        <StyledTabWrapper>
          <HomeBestCategorySelectTab
            categoryTabs={categoryTabs || []}
            selectedId={selectedId}
            onClick={goToAnotherCategory}
          />
        </StyledTabWrapper>
        <ListContainer>{selectedId && <ListProducts />}</ListContainer>
      </>
    </>
  )
}

const StyledTabWrapper = styled.div`
  //  padding: 1.6rem 0 1.6rem 1.6rem;
`

const ListContainer = styled.div`
  padding: ${({ theme: { spacing } }) => `0 ${spacing.size16} ${spacing.size16}`};
`

export default PageHomeBestSellerCategory

export async function getStaticPaths() {
  return {
    paths: [
      { params: { categoryName: BestSellerCategoryTypeEnum.All } },
      { params: { categoryName: BestSellerCategoryTypeEnum.Feed } },
      { params: { categoryName: BestSellerCategoryTypeEnum.Supplies } },
      { params: { categoryName: BestSellerCategoryTypeEnum.Snack } },
      { params: { categoryName: BestSellerCategoryTypeEnum.Styles } },
      { params: { categoryName: BestSellerCategoryTypeEnum.HealthCare } },
    ],
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
})
